var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.activeView === "intro"
    ? _c(
        "div",
        {
          staticClass: "row d-flex justify-content-center",
          attrs: { id: "intro-content" },
        },
        [
          _c("div", { staticClass: "col-12 col-md-9 text-center" }, [
            _c("div", {
              staticClass: "text-primary font-size-28 me-1",
              class: ["icon", _vm.dto.introContent.icon],
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c("div", [
              _c("p", {
                staticClass: "h4 fw-bold",
                domProps: { innerHTML: _vm._s(_vm.dto.introContent.title) },
              }),
              _vm._v(" "),
              _c("p", {
                staticClass: "lead mb-0 py-0",
                domProps: { innerHTML: _vm._s(_vm.dto.introContent.text) },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-md-9 pt-1" },
            [
              _c("Bouton", {
                staticClass: "w-100 mw-100",
                attrs: {
                  id: "add-offer",
                  "is-button": true,
                  "is-primary": false,
                  label: _vm.dto.introContent.addButton.label,
                  href: _vm.dto.introContent.addButton.href,
                  "tms-category": _vm.dto.introContent.addButton.tms.category,
                  "tms-action": _vm.dto.introContent.addButton.tms.action,
                  "tms-label": _vm.dto.introContent.addButton.tms.label,
                },
                on: { click: _vm.onAddOfferClick },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-md-9 pt-1" },
            [
              _c("Bouton", {
                staticClass: "w-100 mw-100",
                attrs: {
                  id: "show-form",
                  "is-button": true,
                  "is-primary": false,
                  label: _vm.dto.introContent.formButton.label,
                  href: _vm.dto.introContent.formButton.href,
                  "tms-category": _vm.dto.introContent.formButton.tms.category,
                  "tms-action": _vm.dto.introContent.formButton.tms.action,
                  "tms-label": _vm.dto.introContent.formButton.tms.label,
                },
                on: { click: _vm.onShowFormClick },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.enableContinueWithoutDiscount &&
          _vm.dto.introContent.continueWithoutDiscountButton
            ? _c("div", { staticClass: "d-flex justify-content-center pt-1" }, [
                _c("a", {
                  staticClass: "ob1-link ob1-link-arrow",
                  attrs: {
                    id: "continue-without-discount",
                    href: _vm.dto.introContent.continueWithoutDiscountButton
                      .href,
                    "data-oevent-category":
                      _vm.dto.introContent.continueWithoutDiscountButton.tms
                        .category,
                    "data-oevent-action":
                      _vm.dto.introContent.continueWithoutDiscountButton.tms
                        .action,
                    "data-oevent-label":
                      _vm.dto.introContent.continueWithoutDiscountButton.tms
                        .label,
                  },
                  domProps: {
                    textContent: _vm._s(
                      _vm.dto.introContent.continueWithoutDiscountButton.label
                    ),
                  },
                  on: { click: _vm.onContinueWithoutDiscountClick },
                }),
              ])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }